import AppRoutes from 'src/features/AppRoutes'

import { useApp } from './hooks/useApp'

function App(): JSX.Element {
  useApp()

  return <AppRoutes />
}

export default App
